export default __webpack_public_path__ + "static/media/isip-icon.2d6aefa5.svg";